import {BrowserRouter, Route, Routes} from "react-router-dom";
import Dashboard from "./pages/dashboard/dashboard.jsx";
import Clientes from "./pages/cadastros/clientes/cliente.jsx";
import ContasAPagar from "./pages/financeiro/contasapagar/consulta/lista.jsx";
import ListaEmpresa from "./pages/listas/empresa/listaempresa.jsx";
import ListaFornecedor from "./pages/listas/fornecedor/listafornecedor.jsx";
import ListaPlanoDeContas from "./pages/listas/planodecontas/listaplanodecontas.jsx";
import ListaDePortadores from "./pages/listas/portadores/listadeportadores.jsx";
import Home from "./pages/home/home.jsx";
import EmConstrucao from "./pages/emconstrucao/emconstrucao.jsx";
import Provisionamento from "./pages/provisionamento/provisionamento.jsx";
import Login from "./components/login/login.jsx";
import SessionGuard from "./components/sessionguard/sessionguard.jsx";
import ImportarAssociados from "./pages/utilitarios/importarassociados/importarassociados.jsx";

function Rotas(){
    return<BrowserRouter>
        <SessionGuard />
        <Routes>
            <Route path="/" element={<Home/>}  />
            <Route path="/em-construcao" element={<EmConstrucao/>}  />
            <Route path="/produtos/foxfiscal" element={<EmConstrucao/>}  />
            <Route path="/provisionamento" element={<Provisionamento/>}  />
            <Route path="/contatos" element={<Provisionamento/>}  />
            <Route path="/login" element={<Login/>}  />
            <Route path="/dashboard" element={<Dashboard/>}  />
            <Route path="/cadastros/clientes" element={<Clientes/>}  />
            <Route path="/cadastros/empresas" element={<ListaEmpresa/>}  />
            <Route path="/cadastros/fornecedores" element={<ListaFornecedor/>}  />
            <Route path="/cadastros/planodecontas" element={<ListaPlanoDeContas/>}  />
            <Route path="/cadastros/portadores" element={<ListaDePortadores/>}  />
            <Route path="/utilitarios/importar-associados" element={<ImportarAssociados/>}  />
            <Route path="/financeiro/contasapagar/consulta" element={<ContasAPagar/>}  />
        </Routes>
    
    </BrowserRouter>
}

export default Rotas;
